// Main setup for the store object in our application. This is where all the context esq stuff is imported for centralized use in the application

// Imports
import { applyMiddleware, combineReducers, createStore, compose } from "redux";
import { thunk } from "redux-thunk";
import account from "../modules/account/api/state";
import accountDisconnects from "../modules/accountDisconnects/api/state";
import accounting from "../modules/accounting/api/state";
import accountsSearch from "../modules/accountsSearch/api/state";
import apl from "../modules/apl/api/state";
import billing from "../modules/billing/api/state";
import bills from "../modules/bills/api/state";
import delinquencies from "../modules/delinquencies/api/state";
import arReceipts from "../modules/arReceipts/api/state";
import developers from "../modules/developer/api/state";
import disconnects from "../modules/disconnects/api/state";
import disconnectSchedules from "../modules/disconnectSchedules/api/state";
import disconnectHolds from "../modules/disconnectHolds/api/state";
import meters from "../modules/meter/api/state";
import moves from "../modules/moves/api/state";
import notes from "../modules/notes/api/state";
import owners from "../modules/owner/api/state";
import payments from "../modules/payments/api/state";
import properties from "../modules/property/api/state";
import propertyManagers from "../modules/propertyManager/api/state";
import propertyManagerStatuses from "../modules/propertyManagerStatus/api/state";
import propertyStatuses from "../modules/propertyStatus/api/state";
import propertyUtilities from "../modules/propertyUtility/api/state";
import weather from "../modules/weather/api/state";
import rateReferences from "../modules/rateReference/api/state";
import propertyGLCode from "../modules/propertyGLCode/api/state";
import meterReadingsUpload from "../modules/readings-uploads/api/state";
import lockBoxUpload from "../modules/lockbox-uploads/api/state";
import setting from "../modules/settings/api/state";
import snackbar from "../modules/snackbar/api/snackbar";
import units from "../modules/unit/api/state";
import unitRates from "../modules/unitRate/api/state";
import unitTypes from "../modules/unitType/api/state";
import workOrders from "../modules/workOrders/api/state";
import complaints from "../modules/complaints/api/state";
import notification from "../modules/notification/api/state";
import files from "../modules/files/api/state";
import apiKeys from "../modules/apiKeys/api/state";
import contractInvoices from "../modules/contractInvoices/api/state";
import reducer from "../reducers";

// App Imports
import user from "../modules/user/api/state";
import userProfiles from "../modules/userProfiles/api/state";
import vendors from "../modules/vendor/api/state";

// App Reducer
const appReducer = combineReducers({
  user,
  billing,
  weather,
  accounting,
  notes,
  delinquencies,
  disconnects,
  disconnectSchedules,
  disconnectHolds,
  apl,
  accountsSearch,
  setting,
  account,
  bills,
  payments,
  userProfiles,
  meterReadingsUpload,
  moves,
  properties,
  units,
  meters,
  propertyManagers,
  owners,
  developers,
  vendors,
  propertyStatuses,
  unitRates,
  unitTypes,
  propertyUtilities,
  rateReferences,
  propertyGLCode,
  propertyManagerStatuses,
  arReceipts,
  snackbar,
  accountDisconnects,
  workOrders,
  complaints,
  notification,
  lockBoxUpload,
  files,
  apiKeys,
  contractInvoices,
  ...reducer
});

// Root Reducer
export const rootReducer = (state, action) => {
  if (action.type === "RESET") {
    state = undefined;
  }

  return appReducer(state, action);
};

// Load initial state from server side
let initialState;
if (typeof window !== "undefined") {
  initialState = window.__INITIAL_STATE__;
  delete window.__INITIAL_STATE__;
}

// Enable Redux DevTools Extension if available, otherwise use compose
const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

// Store
export const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(applyMiddleware(thunk))
);
